<p-panel header="Speichern">
  <div *ngIf="!pzService.model">Es wurde noch kein Spiel gestartet.</div>
  <form #myForm="ngForm" *ngIf="pzService.model">
    <div class="p-field">
      <span class="p-float-label">
        <p-inputNumber
          mode="decimal"
          id="pointsPlayer1"
          name="pointsPlayer1"
          required
          [(ngModel)]="pzService.model.pointsPlayer1"
          #pointsPlayer1="ngModel"
          inputId="pointsPlayer1"
        ></p-inputNumber>
        <label for="pointsPlayer1">Punkte Spieler 1</label>
      </span>
    </div>
    <div class="p-field m-t--lg m-b--lg">
      <span class="p-float-label">
        <p-inputNumber
          mode="decimal"
          id="pointsPlayer2"
          name="pointsPlayer2"
          required
          [(ngModel)]="pzService.model.pointsPlayer2"
          #pointsPlayer2="ngModel"
          inputId="pointsPlayer2"
        ></p-inputNumber>
        <label for="pointsPlayer2">Punkte Spieler 2</label>
      </span>
    </div>
    <p-button
      (click)="saveResult()"
      label="Ergebnis speichern"
      [disabled]="!myForm.form.valid"
    ></p-button>
  </form>
</p-panel>
